import {
    useMemo,
} from 'react'
import isEmpty from 'lodash/isEmpty'
import {
    useTheme,
} from '@mui/material/styles'

import DataContentWrapper from 'app/shared-components/DataContentWrapper'
import SkyNetSpreadSheet from 'app/shared-components/SkyNetSpreadSheet'

import {
    ForecastData, ForecastDataSpreadsheetColumnsConfig,
} from '../../Forecast.types'

import getConfig from './SingleForecastSpreadsheet.config'

const SingleForecastSpreadsheet = ({
    value,
    onSpreadsheetChange,
    tmpFields,
    disabled = false,
}: Readonly<{
    disabled: boolean,
    value: Record<string, any>[],
    onSpreadsheetChange: (...a: ForecastData[]) => void,
    tmpFields: ForecastDataSpreadsheetColumnsConfig,
}>) => {
    const theme = useTheme()

    const config = useMemo(() => {
        return getConfig({
            tmpFields,
            theme,
        })
    }, [
        tmpFields,
        theme,
    ])

    return (
        <DataContentWrapper isEmpty={isEmpty(value)}>
            <SkyNetSpreadSheet
                value={value}
                config={config}
                onChange={onSpreadsheetChange}
                disabled={disabled}
            />
        </DataContentWrapper>
    )
}

export default SingleForecastSpreadsheet
